import { render, staticRenderFns } from "./StockManage.vue?vue&type=template&id=9b449ea2&scoped=true"
import script from "./StockManage.vue?vue&type=script&lang=js"
export * from "./StockManage.vue?vue&type=script&lang=js"
import style0 from "./StockManage.vue?vue&type=style&index=0&id=9b449ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b449ea2",
  null
  
)

export default component.exports